import { render, staticRenderFns } from "./ArchivedScreeningMenu.vue?vue&type=template&id=2782aa68&scoped=true&"
import script from "./ArchivedScreeningMenu.vue?vue&type=script&lang=js&"
export * from "./ArchivedScreeningMenu.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedScreeningMenu.vue?vue&type=style&index=0&id=2782aa68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2782aa68",
  null
  
)

export default component.exports